<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h3 class="text-center">
            Add or Remove Admin <span class="smh"></span>
          </h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-1 p-0">
          <form @submit.prevent="addadmin">
            <b-form-group
              label="Email of Admin"
              class="label"
              label-for="target"
            >
              <b-form-input
                type="email"
                id="title"
                v-model="user.email"
                @input="checkAdminExists()"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Clearance title (Customize your Admin's Clearance Name. Default is 'Admin')"
              label-for="title"
              class="label"
            >
              <b-form-input
                type="text"
                id="title"
                v-model="user.title"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Admin Level"
              v-if="details.clearance_level == 5"
              class="label"
              label-for="target"
            >
              <b-form-select
                id="target"
                v-model="user.level"
                :options="levels"
                required
              >
                <b-form-select-option value="null"
                  >--Clearance Level--</b-form-select-option
                >
              </b-form-select>
            </b-form-group>

            <b-form-group
              v-if="details.clearance_level == 5"
              label="Select Admin Roles"
            >
              <b-form-checkbox
                v-model="checkedall"
                class="mb-3"
                @change="checkAll"
                :indeterminate="indeterminate"
              >
                Select All
              </b-form-checkbox>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="user.roles"
                :options="rolearray"
                @change="isAllchecked"
                stacked
              ></b-form-checkbox-group>
            </b-form-group>

            <b-form-group
              v-if="details.clearance_level != 5"
              label="Select Admin Roles"
            >
              <b-form-checkbox
                v-model="checkedall2"
                class="mb-3"
                @change="checkAll2"
                :indeterminate="indeterminate2"
              >
                Select All
              </b-form-checkbox>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="user.roles"
                :options="rolearray2"
                @change="isAllchecked2"
                stacked
              ></b-form-checkbox-group>
            </b-form-group>

            <div
              v-if="sent"
              class="alert p-3"
              :class="'alert-' + addresponse.status"
            >
              {{ addresponse.msg }}
            </div>

            <b-form-group>
              <div class="text-center">
                <b-overlay
                  :show="sending"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="primary"
                  class=""
                >
                  <div class="mt-4">
                    <b-button
                      :disabled="sending"
                      type="submit"
                      variant="outline-success"
                      class="m-lg-3 mt-2 p-2 action-button"
                    >
                      Add Admin
                    </b-button>
                  </div>
                </b-overlay>
              </div>
            </b-form-group>
          </form>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="">
          <h3 class="text-center">
            {{ details.clearance_organization }} Current Admins
          </h3>
          <div class="text-center list-heads pt-1">
            <p class="head-p">S/N</p>
            <p class="head-p">Admin Name</p>
            <p class="head-p">Admin Email</p>
            <p class="head-p">Clearance</p>
            <p class="head-p">Roles</p>
            <p class="head-p"></p>
          </div>

          <div v-if="orgadminarray[0].count > 0">
            <org-admins
              class="mt-2 maxres"
              v-for="(orgadmin, index) in useorgadminarray"
              :sn="index + 1"
              :orgadmin="orgadmin"
              :key="index"
              :page="pages"
              :interval="intervalnum"
            ></org-admins>
            <paginater
              v-if="orgadminarray[0].data.length > 0"
              :intervalnum="intervalnum"
              :pages="pages"
              :endss="endss"
              :endnum="endnum"
              :datalength="endss"
              @paginator="newPage"
              @changeInterval="effectInterval"
            ></paginater>
          </div>
          <div v-else>
            <h3>{{ details.clearance_organization }} has no Admins yet</h3>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";
import orgAdmins from "@/components/admin/orgAdmins";
import Paginater from "@/components/Paginater";

export default {
  components: {
    orgAdmins,
    Paginater
  },

  data() {
    return {
      user: this.getForm(),
      sending: false,
      sent: false,
      levels: [0, 1, 2, 3, 4, 5],
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      addresponse: "",
      rolearray: [
        { text: "Add & Edit Topics", value: "topics" },
        { text: "Upload and Edit Questions", value: "questions" },
        { text: "Add and Edit Categories", value: "category" },
        { text: "Add and Edit Institutions", value: "institution" },
        { text: "Create and View Testsapces", value: "testspace" },
        { text: "Configure Organization Space", value: "orgspace" },
        { text: "Checking Stocking Stats", value: "stockingstats" },
        { text: "Create and View Ambassadors", value: "ambassadors" },
        { text: "View Company Metrics", value: "metrics" },
        { text: "Create and view Coupons", value: "coupons" },
        { text: "Create and View Partnerships", value: "partnerships" },
        { text: "Create Discount Seasons", value: "discount" },
        { text: "Create and view Contents", value: "contents" },
        { text: "Create and view Notifications", value: "notifications" },
        { text: "Create and View Campaigns", value: "campaigns" },
        { text: "Create and Modify Blogposts", value: "blog" },
        { text: "Create and Modify Admins", value: "createadmins" }
      ],
      rolearray2: [
        { text: "Add & Edit Topics", value: "topics" },
        { text: "Upload and Edit Questions", value: "questions" },
        { text: "Add and Edit Categories", value: "category" },
        { text: "Add and Edit Institutions", value: "institution" },
        { text: "Create and View Testsapces", value: "testspace" },
        { text: "Configure Organization Space", value: "orgspace" },
        { text: "Checking Stocking Stats", value: "stockingstats" }
      ],
      checkedall: false,
      checkedall2: false,
      indeterminate: false,
      indeterminate2: false
      // datacount : this.orgadminarray[0].count
    };
  },
  beforeRouteEnter(to, from, next) {
    let orgname = store.state.loginmaster.details.clearance_organization;
    store.dispatch("admin/fetchOrgadmins", { orgname: orgname });

    next();
  },
  watch: {
    "user.roles"() {
      if (this.details.clearance_level != 5) {
        let srolelength = this.rolearray2.length;
        let urolelength = this.user.roles.length;

        // Check if they are not equal, indicating that one item has been unselected and Not every item is on the checklist
        if (srolelength != urolelength) {
          // Change the Select all value to false so that Admin can select all again
          this.checkedall2 = false;
        } else {
          // Change the Select all value to true
          this.checkedall2 = true;
        }
      } else if (this.details.clearance_level == 5) {
        let srolelength = this.rolearray.length;
        let urolelength = this.user.roles.length;

        // Check if they are not equal, indicating that one item has been unselected and Not every item is on the checklist
        if (srolelength != urolelength) {
          // Change the Select all value to false so that Admin can select all again
          this.checkedall = false;
        } else {
          // Change the Select all value to true
          this.checkedall = true;
        }
      }
    }
  },
  computed: {
    ...mapState({
      users: state => state.admin.allusers,
      details: state => state.loginmaster.details,
      orgadminarray: state => state.admin.organizationadmins,
      adminadded: state => state.admin.adminadded
    }),
    emails() {
      let emailss = this.users;
      return emailss.map(x => x.email);
    },
    useorgadminarray() {
      return this.orgadminarray[0].data.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.orgadminarray[0].data.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(
        this.orgadminarray[0].data.length / this.intervalnum
      );
      return ranger;
    }
  },
  methods: {
    ...mapActions("admin", ["addAdmin", "fetchOrgadmins"]),
    getForm() {
      return {
        email: "",
        title: "Admin",
        level: 1,
        roles: [],
        organization: ""
      };
    },
    addadmin() {
      this.sending = true;
      this.user.organization = this.details.clearance_organization;

      return this.addAdmin(this.user).then(response => {
        this.sending = false;
        this.sent = true;
        this.addresponse = response;
        // console.log(response)

        let orgname = {
          orgname: this.details.clearance_organization
        };
        this.fetchOrgadmins(orgname);

        this.$bvModal
          .msgBoxOk(`${this.addresponse.msg}`, {
            title: "Operation Successful",
            size: "xs",
            centered: true
          })
          .then(() => {});
      });
    },
    newPage(page) {
      // alert(page)
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },
    checkAll(checked) {
      // If the Select All Checkbox is clicked
      // Check if it was checked rather than unchecked
      if (checked) {
        // First empty all user.roles array
        this.user.roles.splice(0);
        // If it was checked, populate the v-model user.roles with the values of the objects in the rolesarray
        this.rolearray.forEach(x => {
          this.user.roles.push(x.value);
        });
      } else {
        // If it was unchecked, depoplulate the v-model of all its items
        this.user.roles.splice(0);
      }
    },
    isAllchecked() {
      // Get the standard role array Length and the User role array length
      let srolelength = this.rolearray.length;
      let urolelength = this.user.roles.length;

      // Check if they are not equal, indicating that one item has been unselected and Not every item is on the checklist
      if (srolelength != urolelength) {
        // change the inderterminate value of the Select all Field
        this.indeterminate = true;
        // Change the Select all value to false so that Admin can select all again
        this.checkedall = false;
      } else {
        // change the inderterminate value of the Select all Field
        this.indeterminate = false;
        // Change the Select all value to true
        this.checkedall = true;
      }
    },
    checkAll2(checked) {
      // If the Select All Checkbox is clicked
      // Check if it was checked rather than unchecked
      if (checked) {
        // First empty all user.roles array
        this.user.roles.splice(0);
        // If it was checked, populate the v-model user.roles with the values of the objects in the rolesarray
        this.rolearray2.forEach(x => {
          this.user.roles.push(x.value);
        });
      } else {
        // If it was unchecked, depoplulate the v-model of all its items
        this.user.roles.splice(0);
      }
    },
    isAllchecked2() {
      // Get the standard role array Length and the User role array length
      let srolelength = this.rolearray2.length;
      let urolelength = this.user.roles.length;

      // Check if they are not equal, indicating that one item has been unselected and Not every item is on the checklist
      if (srolelength != urolelength) {
        // change the inderterminate value of the Select all Field
        this.indeterminate2 = true;
        // Change the Select all value to false so that Admin can select all again
        this.checkedall2 = false;
      } else {
        // change the inderterminate value of the Select all Field
        this.indeterminate2 = false;
        // Change the Select all value to true
        this.checkedall2 = true;
      }
    },

    checkAdminExists() {
      /* This Function checks if the email of the user already exists as an Admin */

      // Find the User email in the already retrieved existing Admins array
      // Returns undefined if does not exist and returns the user admin details if it exists
      let admin = this.orgadminarray[0].data.find(
        x => x.admin_email == this.user.email
      );

      // If it does not returns undefined populate the fields with pre-existing data
      if (admin != undefined) {
        this.user.title = admin.clearance;
        this.user.level = admin.clearance_level;
        this.user.roles = admin.roles;
      } else {
        this.user.title = "Admin";
        this.user.level = 1;
        this.user.roles = [];
      }
    }
  }
};
</script>

<style scoped>
.list-heads {
  background-color: #263056;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row wrap;
}
.head-p {
  width: 17%;
  padding: 2px;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
}
</style>
